import { all, call, put, takeLatest } from "redux-saga/effects";
import CommonService from "../../services/common.service";
import { getCurrenciesFailed, getCurrenciesSuccess } from "./commonSlice";

function* commonWatcher() {
  yield takeLatest("common/getCurrencies", getCurrenciesSaga);
}

function* getCurrenciesSaga(action) {
  try {
    const response = yield call(CommonService.getCurrencies, action.payload);

    if (response.status) {
      yield put(getCurrenciesSuccess(response.data));
    } else {
      yield put(getCurrenciesFailed(response.message));
    }
  } catch (err) {
    yield put(getCurrenciesFailed(err.message));
  }
}

export default function* commonSaga() {
  yield all([commonWatcher()]);
}
